import React, { useState } from "react";
import { Box, Typography } from "@mui/material";
import HPButton from "@/components/common/Button";

interface ApplyColorToAllProps {
  onApply: (color: string) => void;
  defaultColor?: string;
  /** Current effective color of every visible item — used to disable a no-op apply. */
  appliedColors?: string[];
}

const ApplyColorToAll: React.FC<ApplyColorToAllProps> = ({
  onApply,
  defaultColor = "#57bfe7",
  appliedColors = [],
}) => {
  const [color, setColor] = useState(defaultColor);

  const alreadyAppliedToAll =
    appliedColors.length > 0 &&
    appliedColors.every((c) => c.toLowerCase() === color.toLowerCase());

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: 1,
        pb: 1,
        mb: 0.5,
        borderBottom: "1px solid #eee",
      }}
    >
      <Typography variant="body2" sx={{ flex: 1, fontSize: "12px" }}>
        Apply one color to all
      </Typography>
      <input
        type="color"
        value={color}
        onChange={(e) => setColor(e.target.value)}
        style={{
          width: 32,
          height: 24,
          cursor: "pointer",
          border: "1px solid #ccc",
          borderRadius: 4,
          padding: 0,
        }}
      />
      <HPButton
        size="small"
        variant="outlined"
        color="primary"
        disabled={alreadyAppliedToAll}
        onClick={() => onApply(color)}
      >
        Apply to all
      </HPButton>
    </Box>
  );
};

export default ApplyColorToAll;
